const initialized = new WeakSet();

/** Enhance WooCommerce's two native forms without replacing their submit handlers. */
export function initializeAccountTabs(root) {
    const auth = root.querySelector('.OvAccountAuth--registration');
    const tablist = auth?.querySelector('[data-account-tabs]');
    if (!tablist || initialized.has(tablist)) return;
    const tabs = [...tablist.querySelectorAll('[data-account-tab]')];
    const panels = [auth.querySelector('#customer_login > .u-column1'), auth.querySelector('#customer_login > .u-column2')];
    if (tabs.length !== 2 || panels.some((panel) => !panel)) return;
    initialized.add(tablist);
    const view = root.ownerDocument.defaultView;
    const activate = (index, updateLocation = false) => {
        tabs.forEach((tab, i) => {
            tab.setAttribute('aria-selected', String(i === index));
            tab.tabIndex = i === index ? 0 : -1;
            panels[i].hidden = i !== index;
        });
        if (updateLocation) {
            const url = new URL(view.location.href);
            url.hash = tabs[index].dataset.accountTab;
            view.history.replaceState(view.history.state, '', url);
        }
    };
    tablist.setAttribute('role', 'tablist');
    tabs.forEach((tab, index) => {
        const name = tab.dataset.accountTab;
        tab.id = `account-${name}-tab`;
        tab.setAttribute('role', 'tab');
        tab.setAttribute('aria-controls', `account-${name}-panel`);
        panels[index].id = `account-${name}-panel`;
        panels[index].setAttribute('role', 'tabpanel');
        panels[index].setAttribute('aria-labelledby', tab.id);
        tab.addEventListener('click', () => activate(index, true));
        tab.addEventListener('keydown', (event) => {
            const next = { ArrowRight: (index + 1) % tabs.length, ArrowLeft: (index + tabs.length - 1) % tabs.length, Home: 0, End: tabs.length - 1 }[event.key];
            if (next === undefined) return;
            event.preventDefault();
            activate(next, true);
            tabs[next].focus();
        });
    });
    const initial = auth.dataset.accountActive || (view.location.hash === '#register' ? 'register' : 'login');
    activate(initial === 'register' ? 1 : 0);
    auth.classList.add('OvAccountAuth--tabbed');
    tablist.hidden = false;
    view.addEventListener('hashchange', () => activate(view.location.hash === '#register' ? 1 : 0));
}
